import { useState } from "react";
import { NavLink } from "react-router-dom";
import "../HelpDropdown/HelpDropdown.scss";

const HelpDropdown = ({ variant = "default" }) => {
  const [open, setOpen] = useState(false);

  return (
    <li className={`header__nav-item dropdown header__nav-item--${variant}`}>
      <button
        onClick={() => setOpen(!open)}
        className="dropdown-toggle"
        aria-haspopup="true"
        aria-expanded={open}
      >
        {/* Help ▾ */}
        Help
      </button>

      <ul className={`dropdown-menu ${open ? "show" : ""}`}>
        <li>
          <NavLink
            to="/therapists"
            className="dropdown-link"
            onClick={() => setOpen(false)}
          >
            Therapists
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/medHelp"
            className="dropdown-link"
            onClick={() => setOpen(false)}
          >
            Resources
          </NavLink>
        </li>
      </ul>
    </li>
  );
};

// const HelpDropdown = () => {
//   const [open, setOpen] = useState(false);

//   return (
//     <li className="header__nav-item dropdown">
//       <button
//         onClick={() => setOpen(!open)}
//         className="dropdown-toggle"
//         aria-haspopup="true"
//         aria-expanded={open}
//       >
//         {/* Help ▾ */}
//         Help
//       </button>

//       <ul className={`dropdown-menu ${open ? "show" : ""}`}>
//         <li>
//           <NavLink
//             to="/therapists"
//             className="dropdown-link"
//             onClick={() => setOpen(false)}
//           >
//             Therapists
//           </NavLink>
//         </li>
//         <li>
//           <NavLink
//             to="/medHelp"
//             className="dropdown-link"
//             onClick={() => setOpen(false)}
//           >
//             Resources
//           </NavLink>
//         </li>
//       </ul>
//     </li>
//   );
// };

export default HelpDropdown;
